import { render, staticRenderFns } from "./djSignOrSeal.vue?vue&type=template&id=22b2f8b3&scoped=true"
import script from "./djSignOrSeal.vue?vue&type=script&lang=js"
export * from "./djSignOrSeal.vue?vue&type=script&lang=js"
import style0 from "./djSignOrSeal.vue?vue&type=style&index=0&id=22b2f8b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b2f8b3",
  null
  
)

export default component.exports